export const depositTransaction = {
  depositTransactions: "Deposit Transactions",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  user: "User",
  channel: "Channel",
  amount: "Amount",
  date: "Date",
  approvedBy: "Approved By",
  username: "Username",
  all: "All",
  adminTopup: "ADMIN_TOPUP",
  affiliateDownline: "AFFILIATE_DOWNLINE",
  affiliateCommissions: "AFFILIATE_COMMISSION",
  filter: "Filter",
  cancel: "Cancel",
  approveMessage: "Approve Message",
  refCode: "Reference Code",
};
